import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from '../_services/common.service';
import { UserInfoService } from '../_services/userInfo.service';

@Injectable({
  providedIn: 'root'
})
export class RfidServiceService {

  constructor(private commonService: CommonService,readonly userInfoService: UserInfoService,
    private http: HttpClient) { }


  getAllRfids(index, rows, column, direction, search) {
    let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/rfids', headers);
  }

  getAssignedRfids(index, rows, column, direction, search) {
    let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'assign': String(true),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/rfids', headers);
  }

  /**
   * Fetch All Assigned RFIDs
   */
  getAllAssignedRfids(index, rows, column, direction, search) {
    const headers = { headers: { assign: String(true),'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID, 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/rfids', headers);
  }

  // getAllRfid() {
  //   return this.commonService.getCall(environment.API_BASE_PATH + '/rfids');
  // }

  getRfidDetailsById(id) {
    const headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/rfids/${id}`, headers)
  }

  getMasterCards() {
    const headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + '/rfids/master-id-tag' , headers)
  }

  blockRfidCard(id, data) {
    return this.commonService.patchCall(environment.API_BASE_PATH + `/users/${id}`, data)
  }

  unBlockRfidCard(id) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.patchCall(environment.API_BASE_PATH + `/rfids/${id}/unblock`, {}, headers)
  }

  createRfidCard(data) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.postCall(environment.API_BASE_PATH + '/rfids', data,headers)
  }

  deleteRfidCard(id) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.deleteCall(environment.API_BASE_PATH + `/rfids/${id}`, headers)
  }

  updateRfidCard(data) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.putCall(environment.API_BASE_PATH + '/rfids', data, headers);
  }

  assignRfid(rfid, userId) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.patchCall(environment.API_BASE_PATH + `/rfids/${rfid}/associate?user_id=${userId}`, {} , headers)
  }

  // getAssignedRfidsByCpo(id, index, rows, column, direction, search) {
  //   let headers = { headers: { 'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search), 'assign': String(true) ,'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID} };
  //   return this.commonService.getCall(environment.API_BASE_PATH + `/rfids/cpo/${id}`, headers);
  // }

  /**
   * Fetch All Assigned RFIDs for CPO
   * @param id id of CPO
   */
  getAllAssignedRfidsByCpo(id,index, rows, column, direction, search) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID,'starting_index': String(index), 'max_rows': String(rows), 'sort_by': String(column), 'sort_dir': String(direction), 'search': String(search) } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/rfids/createdBy/${id}` , headers);
  }

  // getAllRfidsForCpo(id, index, rows, column, direction, search) {
  //   let headers = { headers: { 'startingIndex': String(index), 'maxRows': String(rows), 'sortBy': String(column), 'sortDir': String(direction), 'search': String(search) } };
  //   return this.commonService.getCall(environment.API_BASE_PATH + `/rfids/cpo/${id}`, headers);
  // }

  getOtpRFid(id) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.getCall(environment.API_BASE_PATH + `/rfids/${id}/sendOTP`, headers)
  }
  
  patchOtpActivate(id,data,logs){
    let headers = { headers:{'logsDetails':String(logs),'Accept-Version': 'V2'}}
    return this.commonService.patchCall(environment.API_BASE_PATH+`/rfids/${id}/activate`,data,headers)
  }

  changeRejectedStatus(id: any, val) {
    let headers = { headers: { 'Accept-Version': 'V2', 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } };
    return this.commonService.patchCall(environment.API_BASE_PATH + `/rfids/${id}/reactivate`, val , headers);
}
  
}
